import BaseApi from '../../../infraestructure/BaseApi';

export default class ApiSimulatorQuestionCategories extends BaseApi {
    constructor(client, endPoint) {
        super(client, endPoint)
    }
}